import React, { useState } from 'react';
import { Card, Button } from '@douyinfe/semi-ui';
import RichEditor from '../../components/RichEditor';
import styles from './index.module.scss';

const RichEditorTest = () => {
    const [content, setContent] = useState('');

    const handleChange = (value) => {
        setContent(value);
        console.log('Editor content:', value);
    };

    return (
        <div className={styles.container}>
            <Card title="富文本编辑器测试">
                <RichEditor
                    value={content}
                    onChange={handleChange}
                    placeholder="请输入测试内容"
                />
                <div style={{ marginTop: '20px' }}>
                    <Button onClick={() => console.log('当前内容:', content)}>获取内容</Button>
                </div>
            </Card>
        </div>
    );
};

export default RichEditorTest;